"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsciiControlCodes = void 0;
var AsciiControlCodes;
(function (AsciiControlCodes) {
    AsciiControlCodes[AsciiControlCodes["DeviceControl1"] = 17] = "DeviceControl1";
    AsciiControlCodes[AsciiControlCodes["STX_StartOfText"] = 2] = "STX_StartOfText";
    AsciiControlCodes[AsciiControlCodes["ETB_EndOfBlock"] = 23] = "ETB_EndOfBlock";
    AsciiControlCodes[AsciiControlCodes["ETX_EndOfText"] = 3] = "ETX_EndOfText";
    AsciiControlCodes[AsciiControlCodes["EOT_EndOfTransmission"] = 4] = "EOT_EndOfTransmission";
    AsciiControlCodes[AsciiControlCodes["C_ControlMessage"] = 67] = "C_ControlMessage";
    AsciiControlCodes[AsciiControlCodes["P_PixelMode"] = 80] = "P_PixelMode";
    AsciiControlCodes[AsciiControlCodes["S_ScrollMode"] = 83] = "S_ScrollMode";
    AsciiControlCodes[AsciiControlCodes["T_TextMode"] = 84] = "T_TextMode";
    AsciiControlCodes[AsciiControlCodes["RS_RecordSeparator"] = 30] = "RS_RecordSeparator";
})(AsciiControlCodes = exports.AsciiControlCodes || (exports.AsciiControlCodes = {}));
//# sourceMappingURL=AsciiControlCodes.js.map